// secPose v2 default pose. When no og_estimations.toon is loaded there are no
// predicted keypoints, so the first navigable frame is seeded with this neutral
// layout for the annotator to drag into place. Later frames carry forward from
// the previous frame instead (see `hooks/useCarryForwardSeed`).

import type { KeypointName } from '../types';
import { KEYPOINTS } from './keypoints';

// [x_frac, y_frac] of the image, per keypoint. y grows downward.
const DEFAULT_POSE_NORM: Partial<Record<KeypointName, [number, number]>> = {
  pelvis: [0.5, 0.3],
  left_elbow: [0.12, 0.55],
  left_shoulder: [0.26, 0.82],
  right_shoulder: [0.74, 0.82],
  right_elbow: [0.88, 0.55],
};

/** Default starting pose. `imageSize` is `[H, W]`; returns a pixel `[x, y]` per keypoint. */
export function defaultPose(imageSize: [number, number]): Record<KeypointName, [number, number]> {
  const [h, w] = imageSize;
  const out = {} as Record<KeypointName, [number, number]>;
  for (const { name } of KEYPOINTS) {
    const [fx, fy] = DEFAULT_POSE_NORM[name] ?? [0.5, 0.5];
    out[name] = [fx * w, fy * h];
  }
  return out;
}
